import React from 'react';
import { DatePicker, IDatePickerProps } from '../../../../components/date-picker/date-picker';

import { validateDefaultDateFormat, validateExpandedDateFormat } from '../../../../components/date-picker/date-validators';

function isDynamicDate(value: string): boolean {
  const dynamicDatePattern = /(^@)((dd$)|(dd|mm)([+-])([1-9]\d{0,2}))$/;
  return dynamicDatePattern.test(value);
}

export function validateDynamicDate(value: string): Date | string | undefined {
  if (isDynamicDate(value)) {
    return value;
  }
  return undefined;
}

export function DynamicDatePicker(props: Omit<IDatePickerProps, 'validators'>) {
  return (
    <DatePicker
      disableAutoOpen
      invalidDateMessage="Indtast et dato udtryk"
      {...props}
      validators={[validateDynamicDate, validateDefaultDateFormat, validateExpandedDateFormat]}
    />
  );
}
